import * as queries from '@queries/utils';

export const fetchSalesDetails = () => queries.getQuery('/api/sales-details');

export const createSalesDetails = (salesDetails) => queries.postQuery('/api/sales-details', salesDetails);

export const updateSalesDetails = (salesDetails) => queries.putQuery(`/api/sales-details`, salesDetails);

export const deleteSalesDetails = (salesDetailsToDelete) => queries.deleteQuery(`/api/sales-details`, salesDetailsToDelete);